import Button from './button';
import ButtonGroup from './group';
import './styles/index.scss';
const ExpandedButton = Button;
ExpandedButton.Group = ButtonGroup;
export { ButtonGroup };
export default ExpandedButton;
